import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from "@enviroments/environment";
import { Observable } from "rxjs";
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';

@Injectable({
    providedIn: 'root'
})

export class WishListPdtService {
    constructor(private _http: HttpClient) { }

    loadPdtWishList(params: any): Observable<OrdPdtModel[]>{
        let url = `${environment.apiUrl}/product/wishlist/search`;

        return this._http.post<OrdPdtModel[]>(url, params);
    }

    countPdtWishList(params: any): Observable<number>{
        let url = `${environment.apiUrl}/product/wishlist/count`;

        return this._http.post<number>(url, params);
    }

    savePdtWishList(pdtCd: string, userid: string) {
        let url = `${environment.apiUrl}/product/wishlist/save?comId=${environment.comId}&userid=${userid}&pdtCd=${pdtCd}`

        return this._http.get(url);
    }

    delPdtWishList(pdtCd: string, userid: string) {
        let url = `${environment.apiUrl}/product/wishlist/del?comId=${environment.comId}&userid=${userid}&pdtCd=${pdtCd}`

        return this._http.get(url);
    }
}